/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectType } from './subjectType.model';
import { SubjectSource } from './subjectSource.model';
import { Subjectable } from './subjectable.model';
import { Contact } from './contact.model';
import { HouseNumberType } from './houseNumberType.model';


export interface Subject { 
    actualised: boolean;
    castObce?: string;
    charosKod?: number;
    charosNazev?: string;
    cisloDomovni?: number;
    cisloOrientacni?: string;
    contact: Contact;
    contactId?: number;
    contractRole?: string;
    cpCe?: HouseNumberType;
    displayName?: string;
    endDate?: string;
    ico?: string;
    id?: number;
    idJe1PartnerBsm?: number;
    idJe2PartnerBsm?: number;
    isConcerned?: boolean;
    jmeno?: string;
    lpisId?: number;
    mestskaCast?: string;
    nazev?: string;
    obec?: string;
    okres?: string;
    opsubType?: SubjectType;
    orderContactName?: string;
    orderName?: string;
    prijmeni?: string;
    psc?: string;
    representativeCount?: number;
    representativeNames?: string;
    rodneCislo?: string;
    startDate?: string;
    stat?: string;
    subjectId?: number;
    subjectPartner1?: Subjectable;
    subjectPartner2?: Subjectable;
    subjectSource?: SubjectSource;
    subjectValidity?: string;
    titulPredJmenem?: string;
    titulZaJmenem?: string;
    ulice?: string;
    userName?: string;
}
export namespace Subject {
}


